
import React from "react";
import PhotoPicker from "../PhotoPicker";
import HouseSelection from "../../Statistic/HouseSelection";
import FloorSelection from "../../Statistic/floorSelection";

import {
    Overlay,
    Modal,
    Title,
    Field,
    ModalButtons,
    Button
} from "../design";

const NewTaskModal = ({
                          houses,
                          Floors,
                          form,
                          setForm,
                          saving,
                          photoProcessing,
                          onClose,
                          onSave,
                          onPhotos,
                          onOpenCamera,
                          onRemovePhoto,
                          onPreview
                      }) => {
    const busy = saving || photoProcessing;

    function update(key, value) {
        setForm(prev => ({
            ...prev,
            [key]: value
        }));
    }

    return (
        <Overlay
            onClick={() => {
                if (!busy) onClose();
            }}
        >
            <Modal
                role="dialog"
                aria-modal="true"
                aria-label="Neue Aufgabe"
                onClick={e => e.stopPropagation()}
            >
                <Title>Neue Aufgabe</Title>

                <form onSubmit={onSave}>
                    <Field>
                        <label>Haus auswählen</label>

                        <HouseSelection
                            houses={houses}
                            selectedHouse={form.house}
                            setSelectedHouse={house => {
                                setForm(prev => ({
                                    ...prev,
                                    house,
                                    floor: ""
                                }));
                            }}
                        />
                    </Field>

                    {form.house && (
                        <Field>
                            <label>Etage auswählen</label>

                            <FloorSelection
                                Floors={Floors}
                                selectedHouse={form.house}
                                selectedFloor={form.floor}
                                setSelectedFloor={floor => {
                                    setForm(prev => ({
                                        ...prev,
                                        floor
                                    }));
                                }}
                            />
                        </Field>
                    )}

                    <PhotoPicker
                        label="Fotos (vor der Arbeit)"
                        photos={form.photos}
                        disabled={saving}
                        processing={photoProcessing}
                        onFiles={files =>
                            onPhotos(files, "create")
                        }
                        onCamera={() =>
                            onOpenCamera("create")
                        }
                        onRemove={index =>
                            onRemovePhoto("create", index)
                        }
                        onPreview={onPreview}
                    />

                    <Field>
                        <label htmlFor="todo-comment">
                            Kommentar
                        </label>

                        <textarea
                            id="todo-comment"
                            required
                            value={form.comment}
                            onChange={e =>
                                update("comment", e.target.value)
                            }
                            placeholder="Aufgabe beschreiben..."
                        />
                    </Field>

                    <Field>
                        <label htmlFor="todo-author">
                            Von wem?
                        </label>

                        <input
                            id="todo-author"
                            required
                            value={form.author}
                            onChange={e =>
                                update("author", e.target.value)
                            }
                            placeholder="Name"
                        />
                    </Field>

                    <Field>
                        <label htmlFor="todo-date">
                            Datum
                        </label>

                        <input
                            id="todo-date"
                            type="date"
                            required
                            value={form.date}
                            onChange={e =>
                                update("date", e.target.value)
                            }
                        />
                    </Field>

                    <ModalButtons>
                        <Button
                            type="button"
                            $secondary
                            disabled={busy}
                            onClick={onClose}
                        >
                            Abbrechen
                        </Button>

                        <Button
                            type="submit"
                            disabled={busy || !form.photos.length}
                        >
                            {saving ? "Speichern..." : "Speichern"}
                        </Button>
                    </ModalButtons>
                </form>
            </Modal>
        </Overlay>
    );
};

export default NewTaskModal;
